import { render, staticRenderFns } from "./intranetProfitRecord.vue?vue&type=template&id=fe85a98a&scoped=true"
import script from "./intranetProfitRecord.vue?vue&type=script&lang=js"
export * from "./intranetProfitRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe85a98a",
  null
  
)

export default component.exports